<div
  class="qb-main-container"
  data-widget-name="PUSH-NOTIFICATION"
  id="push-notification-parent-div"
>
  <div class="qb-w-100">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div>
    <div class="qb-header-pn">
      <div class="qb-header-div-pn">
        <div class="qb-d-flex qb-ai-center qb-jc-space-between">
          <div class="qb-filter-wrapper-pn">
            <div class="qb-heading-analytics-text">
              {{ "SHARED_PAGE.TEMPLATE_NAME" | i18nTranslate }}
            </div>
            <div>
              <div
                class="formDiv-pn"
                [ngClass]="{
                  error:
                    (nameError && submit) ||
                    (templateName.length === 0 && submit)
                }"
              >
                <input
                  (keypress)="templateNameKeyPress($event)"
                  (paste)="templateNamePaste($event)"
                  placeholder="Enter Template Name"
                  class="formInput-pn"
                  type="text"
                  [(ngModel)]="templateName"
                />
                <span class="template-name-text-limiter"
                  >{{ templateName.length
                  }}<span style="color: #cccccc">/50</span></span
                >
              </div>
              <em *ngIf="nameErrorText.length > 0" class="qb-error-message">{{nameErrorText}}</em>
            </div>
          </div>
          <div>
            <button
              type="button"
              class="primary-button"
              (click)="saveTemplate()"
            >
              Save and Exit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="qb-w-100">
    <div class="qb-header-pn">
      <div>
        <div class="qb-pn-main-edit-container">
          <div>
            <div class="qb-input-data-container">
              <div class="module-heading">Message</div>
              <div class="qb-label-content-wrapper">
                <div
                  class="tabs-challenge"
                  *ngIf="aliasCountryCode && aliasCountryCode?.length > 0"
                >
                  <div class="qb-tab-container">
                    <div
                      class="tab-label"
                      *ngFor="let type of languageTypeList"
                      (click)="setLanguageType(type)"
                      [ngClass]="{
                        'active-category-challenge':
                          selectedLanguageType === type.value
                      }"
                    >
                      {{ type.displayName }}
                      <span class="material-symbols-outlined" style="font-size: 20px; color: red; margin-left: 10px;"
                      *ngIf="(body.length === 0)  && submit && type.value === 'DEFAULT'">
                        error
                    </span>
                    </div>
                  </div>
                </div>
                <div>
                  <span
                    class="qb-language-text"
                    (click)="addAliasLanguage()"
                    *ngIf="!aliasCountryCode || aliasCountryCode?.length === 0"
                  >
                    Add Alias Language
                  </span>
                  <span
                    class="qb-language-text"
                    (click)="aliasCountryCode = ''"
                    *ngIf="aliasCountryCode && aliasCountryCode?.length > 0"
                  >
                    Remove Alias Language
                  </span>
                </div>
              </div>

              <div class="qb-label-content-wrapper" *ngIf="checkWhetherAlias()">
                <div>
                  <div class="qb-d-flex qb-fd-coloumn qb-w-25">
                    <app-milestone-common-check-box
                      #languageSelection
                      [isEdit]="true"
                      [selected]="aliasCountryCode"
                      [dataList]="languageList"
                      [isMultiple]="false"
                      [type]="'Language'"
                      (dataSelected)="languageSelected($event)"
                    ></app-milestone-common-check-box>
                  </div>
                </div>
              </div>

              <div class="qb-label-content-wrapper">
                <div>
                  <div class="qb-d-flex qb-fd-coloumn qb-w-25">
                    <app-milestone-common-check-box
                      #templateType
                      [isEdit]="true"
                      [selected]="selectedMeregeTagType"
                      [dataList]="typeOfMergeTags"
                      [isMultiple]="false"
                      [type]="'Template Type'"
                      (dataSelected)="tagTypeSelected($event)"
                    ></app-milestone-common-check-box>
                  </div>
                </div>
              </div>

              <div
                class="qb-label-content-wrapper"
                *ngIf="!checkWhetherAlias()"
              >
                <div class="qb-heading-analytics-text">Header</div>
                <div
                class="text-container"
                [ngClass]="{
                  error: header.length === 0 && submit
                }"
                >
                  <textarea
                    class="textarea qb-textarea-bg"
                    name="header"
                    id="header"
                    cols="20"
                    rows="3"
                    [(ngModel)]="header"
                    [ngClass]="{
                      error: header.length === 0 && submit
                    }"
                    (focusout)="updateMeasurementPointCommentHeader($event)"
                    placeholder="Header"
                  ></textarea>
                </div>

                <div
                  style="
                    display: flex;
                    align-items: baseline;
                    flex-direction: column;
                    gap: 5px;
                    font-size: 13px;
                  "
                >
                  <span>{{
                    "SHARED_PAGE.ADD_MERGE_TAGS" | i18nTranslate
                  }}</span>

                  <div style="margin-left: 12px">
                    <div
                      class="multi-select-panel"
                      id="multi-select-panel-header"
                      (click)="
                        toggleSelect(
                          $event,
                          'multi-select-dropdown-header',
                          'segment-select-header',
                          'multi-select-panel-header',
                          'keyboard-down-icon-container-header',
                          'header'
                        )
                      "
                    >
                      <span>{{
                        "SHARED_PAGE.SELECT_MERGE_TAG" | i18nTranslate
                      }}</span>
                      <div
                        class="keyboard-down-icon-container"
                        id="keyboard-down-icon-container-header"
                      >
                        <svg
                          width="16"
                          height="9"
                          viewBox="0 0 16 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.38672 8.17188C8.17578 8.38281 7.78906 8.38281 7.57812 8.17188L0.828125 1.42188C0.617188 1.21094 0.617188 0.824219 0.828125 0.613281C1.03906 0.402344 1.42578 0.402344 1.63672 0.613281L8 6.97656L14.3281 0.613281C14.5391 0.402344 14.9258 0.402344 15.1367 0.613281C15.3477 0.824219 15.3477 1.21094 15.1367 1.42188L8.38672 8.17188Z"
                            fill="#202224"
                          />
                        </svg>
                      </div>
                    </div>
                    <div style="position: relative">
                      <div
                        class="multi-select-dropdown"
                        id="multi-select-dropdown-header"
                      >
                        <div class="search">
                          <mat-icon class="group-icon">search</mat-icon>
                          <input
                            [(ngModel)]="mergetagFilter"
                            placeholder="Search merge tag"
                            type="text"
                            style="border: none; outline: none"
                          />
                        </div>
                        <div class="border-line"></div>
                        <div id="segment-select-header" class="segment-select">
                          <div>
                            <div
                              class="tag-element"
                              (click)="
                                addMergeTag(
                                  tags['value'],
                                  'multi-select-dropdown-header',
                                  'segment-select-header',
                                  'multi-select-panel-header',
                                  'keyboard-down-icon-container-header',
                                  'header'
                                )
                              "
                              *ngFor="
                                let tags of mergeTags
                                  | labelPipe : mergetagFilter : 'name'
                              "
                            >
                              <span>{{
                                tags["name"]
                                  | i18nDynamicTranslate : "STATIC_PAGE"
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="qb-label-content-wrapper"
                *ngIf="!checkWhetherAlias()"
              >
                <div class="qb-heading-analytics-text">Body</div>
                <div
                  class="text-container"
                  [ngClass]="{
                    error: body.length === 0 && submit
                  }"
                >
                  <textarea
                    class="textarea qb-textarea-bg"
                    name="body"
                    id="body"
                    cols="20"
                    rows="8"
                    [(ngModel)]="body"
                    [ngClass]="{
                      error: body.length === 0 && submit
                    }"
                    (focusout)="updateMeasurementPointCommentBody($event)"
                  ></textarea>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: baseline;
                    flex-direction: column;
                    gap: 5px;
                    font-size: 13px;
                  "
                >
                  <span>{{
                    "SHARED_PAGE.ADD_MERGE_TAGS" | i18nTranslate
                  }}</span>

                  <div style="margin-left: 12px">
                    <div
                      class="multi-select-panel"
                      id="multi-select-panel-body"
                      (click)="
                        toggleSelect(
                          $event,
                          'multi-select-dropdown-body',
                          'segment-select-body',
                          'multi-select-panel-body',
                          'keyboard-down-icon-container-body',
                          'body'
                        )
                      "
                    >
                      <span>{{
                        "SHARED_PAGE.SELECT_MERGE_TAG" | i18nTranslate
                      }}</span>
                      <div
                        class="keyboard-down-icon-container"
                        id="keyboard-down-icon-container-body"
                      >
                        <svg
                          width="16"
                          height="9"
                          viewBox="0 0 16 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.38672 8.17188C8.17578 8.38281 7.78906 8.38281 7.57812 8.17188L0.828125 1.42188C0.617188 1.21094 0.617188 0.824219 0.828125 0.613281C1.03906 0.402344 1.42578 0.402344 1.63672 0.613281L8 6.97656L14.3281 0.613281C14.5391 0.402344 14.9258 0.402344 15.1367 0.613281C15.3477 0.824219 15.3477 1.21094 15.1367 1.42188L8.38672 8.17188Z"
                            fill="#202224"
                          />
                        </svg>
                      </div>
                    </div>
                    <div style="position: relative">
                      <div
                        class="multi-select-dropdown"
                        id="multi-select-dropdown-body"
                      >
                        <div class="search">
                          <mat-icon class="group-icon">search</mat-icon>
                          <input
                            [(ngModel)]="mergetagFilter"
                            placeholder="Search merge tag"
                            type="text"
                            style="border: none; outline: none"
                          />
                        </div>
                        <div class="border-line"></div>
                        <div id="segment-select-body" class="segment-select">
                          <div>
                            <div
                              class="tag-element"
                              (click)="
                                addMergeTag(
                                  tags['value'],
                                  'multi-select-dropdown-body',
                                  'segment-select-body',
                                  'multi-select-panel-body',
                                  'keyboard-down-icon-container-body',
                                  'body'
                                )
                              "
                              *ngFor="
                                let tags of mergeTags
                                  | labelPipe : mergetagFilter : 'name'
                              "
                            >
                              <span>{{
                                tags["name"]
                                  | i18nDynamicTranslate : "STATIC_PAGE"
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="qb-label-content-wrapper" *ngIf="checkWhetherAlias()">
                <div class="qb-heading-analytics-text">Alias Header</div>
                <div
                class="text-container"
                [ngClass]="{
                  error: aliasHeader.length === 0 && submit
                }"
                >
                  <textarea
                    class="textarea qb-textarea-bg"
                    name="aliasHeader"
                    id="aliasHeader"
                    cols="20"
                    rows="3"
                    [(ngModel)]="aliasHeader"
                    [ngClass]="{
                      error: aliasHeader.length === 0 && submit
                    }"
                    (focusout)="updateMeasurementPointCommentAliasHeader($event)"
                    placeholder="Header"
                  ></textarea>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: baseline;
                    flex-direction: column;
                    gap: 5px;
                    font-size: 13px;
                  "
                >
                  <span>{{
                    "SHARED_PAGE.ADD_MERGE_TAGS" | i18nTranslate
                  }}</span>

                  <div style="margin-left: 12px">
                    <div
                      class="multi-select-panel"
                      id="multi-select-panel-alias-header"
                      (click)="
                        toggleSelect(
                          $event,
                          'multi-select-dropdown-alias-header',
                          'segment-select-alias-header',
                          'multi-select-panel-alias-header',
                          'keyboard-down-icon-container-alias-header',
                          'aliasHeader'
                        )
                      "
                    >
                      <span>{{
                        "SHARED_PAGE.SELECT_MERGE_TAG" | i18nTranslate
                      }}</span>
                      <div
                        class="keyboard-down-icon-container"
                        id="keyboard-down-icon-container-alias-header"
                      >
                        <svg
                          width="16"
                          height="9"
                          viewBox="0 0 16 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.38672 8.17188C8.17578 8.38281 7.78906 8.38281 7.57812 8.17188L0.828125 1.42188C0.617188 1.21094 0.617188 0.824219 0.828125 0.613281C1.03906 0.402344 1.42578 0.402344 1.63672 0.613281L8 6.97656L14.3281 0.613281C14.5391 0.402344 14.9258 0.402344 15.1367 0.613281C15.3477 0.824219 15.3477 1.21094 15.1367 1.42188L8.38672 8.17188Z"
                            fill="#202224"
                          />
                        </svg>
                      </div>
                    </div>
                    <div style="position: relative">
                      <div
                        class="multi-select-dropdown"
                        id="multi-select-dropdown-alias-header"
                      >
                        <div class="search">
                          <mat-icon class="group-icon">search</mat-icon>
                          <input
                            [(ngModel)]="mergetagFilter"
                            placeholder="Search merge tag"
                            type="text"
                            style="border: none; outline: none"
                          />
                        </div>
                        <div class="border-line"></div>
                        <div
                          id="segment-select-alias-header"
                          class="segment-select"
                        >
                          <div>
                            <div
                              class="tag-element"
                              (click)="
                                addMergeTag(
                                  tags['value'],
                                  'multi-select-dropdown-alias-header',
                                  'segment-select-alias-header',
                                  'multi-select-panel-alias-header',
                                  'keyboard-down-icon-container-alias-header',
                                  'aliasHeader'
                                )
                              "
                              *ngFor="
                                let tags of mergeTags
                                  | labelPipe : mergetagFilter : 'name'
                              "
                            >
                              <span>{{
                                tags["name"]
                                  | i18nDynamicTranslate : "STATIC_PAGE"
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="qb-label-content-wrapper" *ngIf="checkWhetherAlias()">
                <div class="qb-heading-analytics-text">Alias Body</div>
                <div
                  class="text-container"
                  [ngClass]="{
                    error: aliasBody.length === 0 && submit
                  }"
                >
                  <textarea
                    class="textarea qb-textarea-bg"
                    name="aliasBody"
                    id="aliasBody"
                    cols="20"
                    rows="8"
                    [(ngModel)]="aliasBody"
                    [ngClass]="{
                      error: aliasBody.length === 0 && submit
                    }"
                    (focusout)="updateMeasurementPointCommentAliasBody($event)"
                  ></textarea>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: baseline;
                    flex-direction: column;
                    gap: 5px;
                    font-size: 13px;
                  "
                >
                  <span>{{
                    "SHARED_PAGE.ADD_MERGE_TAGS" | i18nTranslate
                  }}</span>

                  <div style="margin-left: 12px">
                    <div
                      class="multi-select-panel"
                      id="multi-select-panel-alias-body"
                      (click)="
                        toggleSelect(
                          $event,
                          'multi-select-dropdown-alias-body',
                          'segment-select-alias-body',
                          'multi-select-panel-alias-body',
                          'keyboard-down-icon-container-alias-body',
                          'aliasBody'
                        )
                      "
                    >
                      <span>{{
                        "SHARED_PAGE.SELECT_MERGE_TAG" | i18nTranslate
                      }}</span>
                      <div
                        class="keyboard-down-icon-container"
                        id="keyboard-down-icon-container-alias-body"
                      >
                        <svg
                          width="16"
                          height="9"
                          viewBox="0 0 16 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.38672 8.17188C8.17578 8.38281 7.78906 8.38281 7.57812 8.17188L0.828125 1.42188C0.617188 1.21094 0.617188 0.824219 0.828125 0.613281C1.03906 0.402344 1.42578 0.402344 1.63672 0.613281L8 6.97656L14.3281 0.613281C14.5391 0.402344 14.9258 0.402344 15.1367 0.613281C15.3477 0.824219 15.3477 1.21094 15.1367 1.42188L8.38672 8.17188Z"
                            fill="#202224"
                          />
                        </svg>
                      </div>
                    </div>
                    <div style="position: relative">
                      <div
                        class="multi-select-dropdown"
                        id="multi-select-dropdown-alias-body"
                      >
                        <div class="search">
                          <mat-icon class="group-icon">search</mat-icon>
                          <input
                            [(ngModel)]="mergetagFilter"
                            placeholder="Search merge tag"
                            type="text"
                            style="border: none; outline: none"
                          />
                        </div>
                        <div class="border-line"></div>
                        <div
                          id="segment-select-alias-body"
                          class="segment-select"
                        >
                          <div>
                            <div
                              class="tag-element"
                              (click)="
                                addMergeTag(
                                  tags['value'],
                                  'multi-select-dropdown-alias-body',
                                  'segment-select-alias-body',
                                  'multi-select-panel-alias-body',
                                  'keyboard-down-icon-container-alias-body'
                                )
                              "
                              *ngFor="
                                let tags of mergeTags
                                  | labelPipe : mergetagFilter : 'name'
                              "
                            >
                              <span>{{
                                tags["name"]
                                  | i18nDynamicTranslate : "STATIC_PAGE"
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="qb-label-content-wrapper">
                <div class="qb-heading-analytics-text">Image</div>
                <div class="text-container">
                  <div
                    class="textarea"
                    style="
                      height: 64.5px;
                      margin-bottom: 6.5px;
                      border-style: dashed;
                      display: flex;
                      justify-content: center;
                      background-color: #f5f6fa;
                    "
                    appDnd
                    (fileDropped)="onFileDropped($event, 'image')"
                    [ngClass]="{
                      'custom-error': !this.uploadedImg[0] && submit
                    }"
                  >
                    <input
                      style="
                        opacity: 0;
                        position: absolute;
                        width: 100%;
                        height: 65px;
                        top: 0px;
                        left: 0px;
                        cursor: pointer;
                      "
                      type="file"
                      #fileDropRef
                      id="fileDropRef"
                      (click)="$event.target.value = null"
                      (change)="
                        fileBrowseHandler($event, $event.target.files, 'image')
                      "
                      accept=".png, .jpg, .jpeg"
                      title=""
                    />
                    <div class="primary-button">
                      <span *ngIf="!fileuploading"> Browse File </span>
                      <span *ngIf="fileuploading">
                        <mat-spinner diameter="12"></mat-spinner>
                      </span>
                    </div>
                  </div>
                  <p>Maximum file size: 1MB</p>
                  <div
                    *ngIf="uploadedImg"
                    style="
                      display: flex;
                      gap: 16px;
                      flex-wrap: wrap;
                      padding: 10px 0px;
                    "
                  >
                    <div class="img_wrp">
                      <img
                        [src]="uploadedImg"
                        alt=""
                        style="
                          height: 80px;
                          width: 80px;
                          object-fit: contain;
                          border: 1px solid rgba(99, 100, 102, 0.3);
                        "
                      />
                      <mat-icon
                        class="qb-close-button remove-img-btn cursor-pointer"
                        (click)="removeUrl('image')"
                        >cancel</mat-icon
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="qb-p-relative">
            <div class="qb-mobile-screen-container-pn">
              <app-push-notification-view
                [header]="checkWhetherAlias() ? aliasHeader : header"
                [body]="checkWhetherAlias() ? aliasBody : body"
                [uploadedImg]="uploadedImg"
              ></app-push-notification-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
